import * as AboutFeatures01Uploads from "$lib/data/generated/uploads/about/Features 01/uploads.js";
import * as AboutFeatures02Uploads from "$lib/data/generated/uploads/about/Features 02/uploads.js";
import * as AboutHeadUploads from "$lib/data/generated/uploads/about/Head/uploads.js";
import * as AboutPageBannerUploads from "$lib/data/generated/uploads/about/PageBanner/uploads.js";
import * as AboutSideBySide01Uploads from "$lib/data/generated/uploads/about/SideBySide 01/uploads.js";
import * as AboutSideBySide02Uploads from "$lib/data/generated/uploads/about/SideBySide 02/uploads.js";

export const uploads = {
  ...AboutFeatures01Uploads.uploads,
  ...AboutFeatures02Uploads.uploads,
  ...AboutHeadUploads.uploads,
  ...AboutPageBannerUploads.uploads,
  ...AboutSideBySide01Uploads.uploads,
  ...AboutSideBySide02Uploads.uploads
};
